(() => {
    let count = 0;
    const handleHidePriceOnCart = () => {
        const cartDrawer = document.getElementById('upCart');
        if (!cartDrawer || !cartDrawer.shadowRoot) return;
        const cards = cartDrawer.shadowRoot.querySelectorAll('.upcart-upsell-item-card');
        cards.forEach(card => {
            const linkElement = card.tagName === "A" ? card : card.querySelector('a[href*="/products/"]');
            if (!linkElement) return;
            const href = linkElement.getAttribute('href');
            if (!href) return;
            const foundElement = window.Login.elements.find(e => href.includes('/products/' + e.handle) && e.lock);
            if (!foundElement) return;
            const priceElement = card.querySelector('.upcart-upsell-item-price');
            if (!priceElement) return;
            const lockElement = priceElement.querySelector('.bss-lock-element');
            if (lockElement) return;
            // const styleElement = '<style>.upcart-upsell-item-card:has(.bss-lock-element) .upcart-upsells-button{display: none}</style>'
            priceElement.innerHTML = "<div class='bss-lock-element'></div><style>.upcart-upsell-item-card:has(.bss-lock-element) .upcart-upsells-button{display: none}</style>";
        });
    }
    const intervalId = setInterval(() => {
        if (count == 100) {
            return clearInterval(intervalId);
        }
        count++;
        if (window.Login.elements) {
            const config = { attributes: true, childList: true, subtree: true };
            const observer = new MutationObserver(handleHidePriceOnCart);
            observer.observe(document.body, config);

            clearInterval(intervalId)
        }
    }, 300)  
})()